import { z } from "zod";
import type { DefaultValues } from "react-hook-form";

export const collarEditSchema = z.object({
  number: z.string().min(1, "Número do dispositivo é obrigatório"),
  responsibleTeam: z.string().optional(),
});

export type CollarEditFormData = z.infer<typeof collarEditSchema>;

export const collarEditDefaultValues: DefaultValues<CollarEditFormData> = {
  number: "",
  responsibleTeam: "",
};
